var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",class:_vm.type,attrs:{"role":_vm.level}},[_c('div',{staticClass:"icon-container"},[(_vm.icon)?_c('i',{class:_vm.icon}):(_vm.type === 'success')?_c('checkbox-icon'):_c('info-icon')],1),_vm._v(" "),_c('div',{staticClass:"message-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }